<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>场地类型列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>类型列表</h2>
                <div class="item" v-if="role_id!=4||(role_id==4&&hasCreat)" @click="addType"><i class="icon el-icon-circle-plus-outline" type="primary"></i>新增类型</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="table p20 bg_fff">
                <el-table :data="typeList" size="mini" border  v-loading="loading" row-key="cate_id" style="width:600px"
                          default-expand-all
                          :tree-props="{children: 'child', hasChildren: 'hasChildren'}">
                    <el-table-column prop="name" label="类型名称" align="center"/>
                    <el-table-column prop="city" label="类型图标" align="center">
                        <template slot-scope="scope">
                            <img :src="scope.row.cover|handleImg" alt="" style="width: 50px;height: 50px;" v-if="scope.row.cover">
                            <span v-else>无图片</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { spacecateList} from '../../api/site'
    import { mapState } from 'vuex';
    export default {
        name: "type-list",
        data(){
          return{
              typeList:[],
              loading:false,
              role_id:0,
          }
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        created(){
            this.role_id=localStorage.getItem('ROLE');
            this.siteTypeList();
        },
        methods:{
            siteTypeList(){
                this.loading=true;
                spacecateList().then(res=>{
                    this.loading=false;
                    if(res.code==1){
                        this.typeList=res.data;
                    }
                })
            },
            addType(){
                this.$router.push({path: '/site/type'});
            }
        }
    }
</script>

<style scoped>

</style>
